import React from 'react';
import { Search, Filter, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

const DriverFilters = ({ 
  filters, 
  onFiltersChange, 
  onReset, 
  vehicles = [],
  isLoading = false 
}) => {
  const handleFilterChange = (key, value) => {
    onFiltersChange({ [key]: value });
  };

  const handleSearchChange = (e) => {
    handleFilterChange('search', e.target.value);
  };

  const hasActiveFilters = Object.values(filters).some(value => 
    value !== '' && value !== 'all' && value !== null && value !== undefined
  );

  return (
    <div className="space-y-4 p-4 bg-gray-50 dark:bg-gray-800 rounded-lg">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Filter className="h-4 w-4 text-gray-500" />
          <h3 className="text-sm font-medium text-gray-700 dark:text-gray-300">
            Filtres
          </h3>
        </div>
        {hasActiveFilters && (
          <Button
            variant="ghost"
            size="sm"
            onClick={onReset}
            className="text-gray-500 hover:text-gray-700"
          >
            <X className="h-4 w-4 mr-1" />
            Réinitialiser
          </Button>
        )}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {/* Recherche */}
        <div className="space-y-2">
          <label className="text-xs font-medium text-gray-600 dark:text-gray-400">
            Recherche
          </label>
          <div className="relative">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
            <Input
              placeholder="Nom, téléphone, permis, ID LogiConnect..."
              value={filters.search || ''}
              onChange={handleSearchChange}
              className="pl-10"
              disabled={isLoading}
            />
          </div>
        </div>

        {/* Statut */}
        <div className="space-y-2">
          <label className="text-xs font-medium text-gray-600 dark:text-gray-400">
            Statut
          </label>
          <Select
            value={filters.status || ''}
            onValueChange={(value) => handleFilterChange('status', value)}
            disabled={isLoading}
          >
            <SelectTrigger>
              <SelectValue placeholder="Tous les statuts" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">Tous les statuts</SelectItem>
              <SelectItem value="ACTIVE">Actif</SelectItem>
              <SelectItem value="INACTIVE">Inactif</SelectItem>
              <SelectItem value="SUSPENDED">Suspendu</SelectItem>
            </SelectContent>
          </Select>
        </div>

        {/* Véhicule assigné */}
        <div className="space-y-2">
          <label className="text-xs font-medium text-gray-600 dark:text-gray-400">
            Véhicule assigné
          </label>
          <Select
            value={filters.assigned_vehicle || ''}
            onValueChange={(value) => handleFilterChange('assigned_vehicle', value)}
            disabled={isLoading}
          >
            <SelectTrigger>
              <SelectValue placeholder="Tous les véhicules" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">Tous les véhicules</SelectItem>
              <SelectItem value="none">Non assigné</SelectItem>
              {vehicles.map((vehicle) => (
                <SelectItem key={vehicle.id} value={vehicle.id}>
                  {vehicle.plate_number} - {vehicle.make} {vehicle.model}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        {/* Statut permis */}
        <div className="space-y-2">
          <label className="text-xs font-medium text-gray-600 dark:text-gray-400">
            Permis
          </label>
          <Select
            value={filters.license_status || ''}
            onValueChange={(value) => handleFilterChange('license_status', value)}
            disabled={isLoading}
          >
            <SelectTrigger>
              <SelectValue placeholder="Tous les statuts" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">Tous les statuts</SelectItem>
              <SelectItem value="valid">Valide</SelectItem>
              <SelectItem value="expired">Expiré</SelectItem>
              <SelectItem value="expiring_soon">Expire bientôt</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>

      {/* Filtres secondaires */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Expérience */}
        <div className="space-y-2">
          <label className="text-xs font-medium text-gray-600 dark:text-gray-400">
            Expérience (années)
          </label>
          <Input
            type="number"
            placeholder="Années d'expérience"
            value={filters.min_experience || ''}
            onChange={(e) => handleFilterChange('min_experience', e.target.value)}
            disabled={isLoading}
          />
        </div>

        {/* Date d'embauche */}
        <div className="space-y-2">
          <label className="text-xs font-medium text-gray-600 dark:text-gray-400">
            Embauché après
          </label>
          <Input
            type="date"
            value={filters.hired_after || ''}
            onChange={(e) => handleFilterChange('hired_after', e.target.value)}
            disabled={isLoading}
          />
        </div>
      </div>

      {/* Indicateur de filtres actifs */}
      {hasActiveFilters && (
        <div className="flex items-center gap-2 text-sm text-blue-600 dark:text-blue-400">
          <Filter className="h-4 w-4" />
          <span>Filtres actifs</span>
        </div>
      )}
    </div>
  );
};

export default DriverFilters;